import { render, staticRenderFns } from "./product-recomend-update-dialog.vue?vue&type=template&id=ad71fbb2&"
import script from "./product-recomend-update-dialog.vue?vue&type=script&lang=js&"
export * from "./product-recomend-update-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports